import { UntypedFormArray, UntypedFormControl } from '@angular/forms';

import { DataVariableType } from '@empathy/global/data';

import { LocaleItem } from './locale-item.model';
import { QuestionOption } from './question-option.model';
import { Validator } from './validator.model';
import { VisibilityCondition } from './visibility-condition.model';

export class Question {
  id: string;
  dataVariableTypeId: string;
  typeId: DataVariableType;
  randomizedInd: boolean;
  dataVariableKeyName: string;
  linkedId?: string;
  loopInd?: boolean;
  loopCount?: string;
  groupId?: number;
  dataVariableLabels: LocaleItem[];
  options?: QuestionOption[];
  ranges?: any[]; // TODO: Find object extructure
  validators?: Validator[];
  formControl?: UntypedFormControl | UntypedFormArray;
  displayConfig?: VisibilityCondition;
}
